import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { getFormValues } from 'redux-form'
import {
  Fade,
} from '@material-ui/core'
import { 
  Divider,
  Button
} from 'semantic-ui-react'
import r from 'reactotron-react-js'
import { FileRow } from './FileRow'
import FieldAttachment from './FieldAttachment'
import { StdCard } from 'components'
import { documentType } from '../../helper'

import { ProcurementBody } from '../../../styled'
import { AttachmentInfoContainer } from './styled'
import { AttachmentContainer2, Cont2, SContDetail, AttachmentGroup, AttachmentContent } from './styled'


const Attachment = props => {
  const { 
    isCreate, 
    isEdit, 
    change, 
    valueForm 
  } = props

  var commentAttachments = valueForm&&valueForm.attachments?valueForm.attachments.filter(x=>x.documentCode=="CH01"):[]

  if(valueForm){
    var documentTypesFilter = documentType()
  }

  function setAttachment() {
    if (documentTypesFilter) {
      return documentTypesFilter.map((item, i) => {
        return <FileRow attachmentTitle={item.name} files={valueForm.attachments.filter(item2 => item2.documentCode === item.code)} />
      })
    } else {
      return null
    }
  }

  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdCard title="Attachment">
          {(isCreate||isEdit) ? (
            <FieldAttachment />
          ) : (
            <AttachmentInfoContainer>
              {valueForm&&valueForm.attachments&&setAttachment()}
            </AttachmentInfoContainer>
          )}
        </StdCard>
        {
          commentAttachments.length ? 
            <StdCard title='Attachments (from comment)' style={{ marginTop: '15px' }} >
              <AttachmentContainer2>
                <Cont2>
                  {
                    valueForm.comments.map(a => {
                      let files = commentAttachments.filter(x=>x.commentId===a.id)
                      if(files.length){
                        return(
                          <AttachmentGroup>
                            <div className='attachmentBy'>
                              <span>{a.createdByName}</span>
                              <Moment format='DD MMM YYYY HH:mm'>{a.createdDate}</Moment>
                            </div>
                            <AttachmentContent>
                              {
                                files.map((f,i) => 
                                  <SContDetail style={i==0?{ marginTop: '0px' }:null}>
                                    {/* <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.open(f.urlPath,"_blank"))}/> */}
                                    <Button style={{flex:1,display:'flex',justifyContent:'flex-start'}} type='button' content={<div className='fileName'>{f.originalFilename}</div>} icon='download' labelPosition='left' onClick={()=>(window.location.href = f.urlPath)}/>
                                  </SContDetail>
                                )
                              }
                              <Divider/>
                            </AttachmentContent>
                          </AttachmentGroup>
                        )
                      }else{
                        return null
                      }
                      
                    })
                  }
                </Cont2>
              </AttachmentContainer2>
            </StdCard> : null
        }
      </ProcurementBody>
    </Fade>
  )
  
}
const mapStateToProps = (state, props) => {
  return {
    valueForm: getFormValues('formPOUpdate')(state)||{},
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Attachment)
